import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-attention-modal',
  templateUrl: 'attention-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgTemplateOutlet],
})
export class AttentionModalComponent {
  @Input() type!: 'warning' | 'error' | 'success' | 'scheduled' | 'suspend' | 'resume';

  @Input() title!: string;

  @Input() subtitle!: string | undefined;

  @Input() messageTemplate!: TemplateRef<ElementRef>;

  @Input() buttonsTemplate!: TemplateRef<ElementRef>;
}
